import { Injectable,HostListener  } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {CookieService} from 'angular2-cookie/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { Http,Headers, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { HelperService } from './helper.service';
import {MatSnackBar} from '@angular/material';

@Injectable()

export class AuthGuard implements CanActivate {
  userAuth;
  data:any=[];
  user_token= localStorage.getItem('access_token');
  navigate_route= localStorage.getItem('navigateroute');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});

  constructor(private cookieService: CookieService,private router:Router,private helper:HelperService,private http:Http,private snackbar: MatSnackBar){
    // let currentUrl = this.router.url;
    // alert(currentUrl);
    //alert(this.user_token);
    //console.log(this.user_token);
    //alert(this.navigate_route);

    this.http.get(this.helper.base_url+'http/checkuserLogged?token='+this.user_token)
    .subscribe(data => {
    // if(this.cookieService.get('auth')=="Y"){
      //console.log(data.status);
      if(data.status ==200)
      {
        this.data = JSON.parse(data['_body']);
        if(this.data.status != "error")
        {

          this.userAuth=true;
          this.navigate_route = decodeURIComponent(this.navigate_route);
          this.router.navigateByUrl(this.navigate_route);
        }else{
          //alert("not logged");
          this.userAuth=false;

          //this.router.navigate(["login/"]);
          this.router.navigate(['login/'])
          .then(() => {
            setTimeout(() => {
            window.location.reload();
          }, 2000);
          });
        }
      }
      else{
        this.userAuth=false;
        this.snackbar.open("Session Has Expired,Please Login Again", null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
          //this.router.navigate(["login/"]);
          this.router.navigate(['login/'])
          .then(() => {
            setTimeout(() => {
            window.location.reload();
          }, 2000);
          });
      }

  },
  error =>{
    this.snackbar.open("Session Has Expired,Please Login Again", null, {
      duration:5000,
        extraClasses:'error-snackbar',
        verticalPosition:'top'
      });
    this.userAuth=false;
          //this.router.navigate(["login/"]);
          this.router.navigate(['login/'])
          .then(() => {
            setTimeout(() => {
            window.location.reload();
          }, 2000);
          });
  }
  );
}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      localStorage.setItem('navigateroute', decodeURI(state.url));
      this.navigate_route= localStorage.getItem('navigateroute');
      this.http.get(this.helper.base_url+'http/checkuserLogged?token='+this.user_token)
    .subscribe(data => {
    // if(this.cookieService.get('auth')=="Y"){
      //console.log(data.status);
      if(data.status ==200)
      {
        this.data = JSON.parse(data['_body']);
        if(this.data.status != "error")
        {

          this.userAuth=true;
          this.navigate_route = decodeURIComponent(this.navigate_route);
          this.router.navigateByUrl(this.navigate_route);
        }else{
          //alert("not logged");
          this.userAuth=false;

          //this.router.navigate(["login/"]);
          this.router.navigate(['login/'])
          .then(() => {
            setTimeout(() => {
            window.location.reload();
          }, 2000);
          });
        }
      }
      else{
        this.snackbar.open("Session Has Expired,Please Login Again", null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
        this.userAuth=false;
          //this.router.navigate(["login/"]);
          this.router.navigate(['login/'])
          .then(() => {
            setTimeout(() => {
            window.location.reload();
          }, 2000);
          });
      }

  },
  error =>{
    this.snackbar.open("Session Has Expired,Please Login Again", null, {
      duration:5000,
        extraClasses:'error-snackbar',
        verticalPosition:'top'
      });
    this.userAuth=false;
          //this.router.navigate(["login/"]);
          this.router.navigate(['login/'])
          .then(() => {
            setTimeout(() => {
            window.location.reload();
          }, 2000);
          });
  }
  );
      // alert(state.url);
      // console.log(state.url);
    return this.userAuth;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts